import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';
 
@Injectable()
export class Insights {
    private angularPlugin = new AngularPlugin();
    private appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: environment.instrumentationKey,
            extensions: [this.angularPlugin],
            extensionConfig: {
                [this.angularPlugin.identifier]: {
                    router: this.router,
                    errorServices: [new ErrorHandler()],
                },
            },           
        },
    });
 
    constructor(private router: Router) {
        this.appInsights.loadAppInsights();       
    }
 
    // expose methods that can be used in components and services
    trackException(err: any): void {
        this.appInsights.trackException({ exception: err });
    }

    trackEvent(eventName: string, message: string, extras: any = null): void {
        this.appInsights.trackEvent({ name: eventName, properties: { message: message, extras: extras } });
    }
 
    trackTrace(message: string): void {
        this.appInsights.trackTrace({ message });
    }
}